import { Attachable } from './attachable';
import { AttachmentType } from './enums/attachmentType';

/**
 * This class could later be deprecated. Use Attachment with the corersponding mime-type instead.
 */
export class Image implements Attachable {

  public id: number;
  public type = AttachmentType.GalleryImage;
  public fileName: string;
  public fileUrl: string;
  public data: string; // base64-encoded image-data

  constructor(id: number, fileName: string, fileUrl?: string, data?: string) {
    this.id = id;
    this.fileName = fileName;

    if (fileUrl) {
      this.fileUrl = fileUrl;
    }

    if (data) {
      this.data = data;
    }
  }
}
